import { render } from "./Сarousel.vue?vue&type=template&id=732b42ee&scoped=true"
import script from "./Сarousel.vue?vue&type=script&lang=js"
export * from "./Сarousel.vue?vue&type=script&lang=js"

import "./Сarousel.vue?vue&type=style&index=0&id=732b42ee&scoped=true&lang=css"

import exportComponent from "/Users/user/Desktop/Проекты/territory_transport/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-732b42ee"]])

export default __exports__